import { Box, Stack } from "@mui/material";
import { Custom, Field, Workflow } from "components";
import { useApp, useTheme } from "contexts";
import { useWorkflow } from "contexts/components";
import { forwardRef, useEffect } from "react";
import { StringOrOptionType } from "types";
import { Helpers } from "utils";
import { createStep } from "utils/helpers";

const StepDetails = forwardRef(() => {
  const { updateData, data } = useWorkflow<Workflow.Utils.OnboardingType>(); // Get updateData from context
  const { theme } = useTheme();
  const { t } = useApp();

  useEffect(() => {
    updateData("user.city", "");
  }, [data.user.country]);

  return (
    <>
      <Custom.Typography size={theme.font.md} weight={theme.font.bold}>
        {t.component.workflow.onboarding.create_profile}
      </Custom.Typography>

      <Box mt={theme.spacing.md}>
        <Stack spacing={theme.spacing.sm}>
          <Custom.Typography size={theme.font.xs} weight={theme.font.bold}>
            {t.component.workflow.onboarding.onboarding_intro}
          </Custom.Typography>
          <Custom.Typography
            size={theme.font.xs}
            color={theme.color.font.accent}
          >
            {t.component.workflow.onboarding.form_message}
          </Custom.Typography>
        </Stack>
      </Box>

      <Box mt={theme.spacing.md}>
        <Stack spacing={theme.spacing.sm}>
          <Custom.Typography size={theme.font.xs} weight={theme.font.bold}>
            {t.component.workflow.onboarding.my_name_is}
          </Custom.Typography>
          <Custom.TextField
            required
            placeholder={t.placeholder.first_name}
            fullWidth
            value={data.user.first_name}
            onChange={(e) => updateData("user.first_name", e.target.value)}
          />
          <Custom.TextField
            placeholder={t.placeholder.last_name}
            fullWidth
            value={data.user.last_name}
            onChange={(e) => updateData("user.last_name", e.target.value)}
          />
        </Stack>
      </Box>

      <Box mt={theme.spacing.md}>
        <Stack spacing={theme.spacing.sm}>
          <Custom.Typography size={theme.font.xs} weight={theme.font.bold}>
            {t.component.workflow.onboarding.my_date_birth}
          </Custom.Typography>
          <Custom.TextField
            type="date"
            fullWidth
            value={data.user.birth_date || ""}
            onChange={(e) => updateData("user.birth_date", e.target.value)}
          />
        </Stack>
      </Box>

      <Box mt={theme.spacing.md}>
        <Stack spacing={theme.spacing.sm}>
          <Custom.Typography size={theme.font.xs} weight={theme.font.bold}>
            {t.component.workflow.onboarding.i_live_in}
          </Custom.Typography>
          <Field.Search
            name="country"
            value={data.user.country}
            options={Helpers.countries}
            label={t.label.country}
            placeholder={t.placeholder.country}
            onOptionSelect={(selected: StringOrOptionType) =>
              updateData("user.country", selected)
            }
          />
          <Field.Search
            name="city"
            value={data.user.city}
            options={data.user.country ? Helpers.cities(data.user.country) : []}
            label={t.label.city}
            placeholder={t.placeholder.city}
            onOptionSelect={(selected: StringOrOptionType) =>
              updateData("user.city", selected)
            }
          />
        </Stack>
      </Box>

      <Box mt={theme.spacing.md}>
        <Stack spacing={theme.spacing.xs}>
          <Custom.Typography size={theme.font.xs} weight={theme.font.semiBold}>
            {t.component.workflow.onboarding.start_potluck}
          </Custom.Typography>
          <Custom.Typography
            size={theme.font.xs}
            color={theme.color.font.accent}
          >
            {t.component.workflow.onboarding.add_category}
          </Custom.Typography>
        </Stack>
      </Box>
    </>
  );
});

export default createStep<Workflow.Utils.OnboardingType>(StepDetails);
